export const DEFAULT_CONTENT = {
  services: [
    {
      icon: "globe",
      title: "Hemsidor",
      description:
        "Moderna, snabba och mobilanpassade hemsidor som är byggda för att skapa förtroende och få kunder att ta kontakt.",
    },
    {
      icon: "pentool",
      title: "Branding",
      description:
        "Logotyp, färger, typografi och en visuell identitet som gör ditt företag lätt att känna igen.",
    },
    {
      icon: "mappin",
      title: "Google & SEO",
      description:
        "Optimera din digitala närvaro så att kunder enklare kan hitta ditt företag när de söker efter dina tjänster.",
    },
    {
      icon: "megaphone",
      title: "Social Media",
      description:
        "Professionell presentation på sociala medier med en konsekvent och modern visuell stil.",
    },
  ],
  packages: [
    {
      name: "START",
      price: "4 990 kr",
      subtitle: "För dig som vill komma igång snabbt och se professionell ut direkt.",
      badge: "",
      recommended: false,
      features: [
        "Enkel one-page hemsida",
        "Enkel logotyp",
        "Mobilanpassning",
        "Kontaktformulär",
        "Google Maps",
        "Grundläggande SEO",
      ],
    },
    {
      name: "GROW",
      price: "9 990 kr",
      subtitle: "Vår mest populära helhetslösning för företag som vill växa.",
      badge: "Rekommenderas",
      recommended: true,
      features: [
        "Professionell hemsida",
        "Professionell logotyp",
        "Varumärkesfärger & typografi",
        "4–6 sidor",
        "Mobilanpassning",
        "Grundläggande SEO",
        "Google Business-optimering",
        "Uppsättning av sociala medier",
        "Professionell copywriting",
      ],
    },
    {
      name: "PREMIUM",
      price: "17 990 kr",
      subtitle: "För dig som vill dominera din lokala marknad helt och hållet.",
      badge: "",
      recommended: false,
      features: [
        "Komplett varumärkesprofil",
        "Professionell hemsida med flera sidor",
        "6–10 sidor",
        "Avancerad SEO",
        "Google Business-optimering",
        "Mallar för sociala medier",
        "Boknings- & kontaktsystem",
        "Skräddarsydd landningssida",
        "30 dagars support",
      ],
    },
  ],
  maintenance: [
    {
      name: "Website Care",
      price: "499 kr/mån",
      description: "Vi håller din hemsida säker, snabb och uppdaterad.",
      badge: "",
      recommended: false,
      features: ["Uppdateringar & säkerhetskopior", "Övervakning av drift", "Support via e-post"],
    },
    {
      name: "Growth",
      price: "999 kr/mån",
      description: "För dig som vill utvecklas och synas bättre varje månad.",
      badge: "Populärast",
      recommended: true,
      features: [
        "Allt i Website Care",
        "Månadsvisa SEO-justeringar",
        "Små text- & bildändringar",
        "Prioriterad support",
      ],
    },
    {
      name: "Growth Pro",
      price: "1 499 kr/mån",
      description: "Din digitala partner för långsiktig tillväxt.",
      badge: "",
      recommended: false,
      features: [
        "Allt i Growth",
        "Löpande innehåll & vidareutveckling",
        "Google Business-underhåll",
        "Kvartalsvis strategisamtal",
      ],
    },
  ],
  projects: [
    {
      title: "Trädgård & Mark",
      category: "Trädgård & landskapsanläggning",
      description: "Koncepthemsida för ett modernt svenskt trädgårds- och markentreprenadföretag.",
      image:
        "https://images.unsplash.com/photo-1741252453954-879d8c395d71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBzY2FuZGluYXZpYW4lMjBnYXJkZW4lMjBsYW5kc2NhcGluZyUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODgzODYyNjB8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Nordic Clean",
      category: "Städ & facility service",
      description: "Koncepthemsida och varumärke för ett svenskt städföretag.",
      image:
        "https://images.unsplash.com/photo-1609081144289-eacc3108cd03?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMG1pbmltYWwlMjBpbnRlcmlvciUyMGRlc2lnbiUyMHdoaXRlJTIwbGl2aW5nJTIwcm9vbXxlbnwwfHx8fDE3ODgzODYyNjB8MA&ixlib=rb-4.1.0&q=85",
    },
    {
      title: "Bygg & Renovering",
      category: "Bygg & totalentreprenad",
      description: "Koncepthemsida och visuell identitet för ett svenskt byggföretag.",
      image:
        "https://images.unsplash.com/photo-1556156653-e5a7c69cc263?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjB0aW1iZXIlMjB3b29kJTIwY29uc3RydWN0aW9uJTIwYXJjaGl0ZWN0dXJlJTIwaG91c2V8ZW58MHx8fHwxNzg4Mzg2MjYwfDA&ixlib=rb-4.1.0&q=85",
    },
  ],
  socials: { instagram: "", facebook: "", linkedin: "" },
  faq: {
    tag: "Vanliga frågor",
    heading: "Frågor & svar om hemsida, pris och reklam.",
    sub: "Det här undrar de flesta småföretagare innan de hör av sig till Nivå Digital.",
    items: [
      { q: "Vad kostar en hemsida hos Nivå Digital?", a: "Vi arbetar med fasta priser så att du vet exakt vad du betalar. En professionell hemsida (webbsida) för småföretag börjar på 4 990 kr i vårt START-paket, vårt populäraste paket GROW kostar 9 990 kr och PREMIUM 17 990 kr. Inga dolda avgifter." },
      { q: "Kan man få en billig hemsida som ändå ser professionell ut?", a: "Ja. Vår idé med Nivå Digital är just att ge småföretag en prisvärd hemsida med premiumkänsla – modern design, mobilanpassning, kontaktformulär och grundläggande SEO ingår redan i det billigaste paketet." },
      { q: "Hjälper ni med reklam och marknadsföring också?", a: "Absolut. Utöver hemsidor gör vi logotyp och branding, uppsättning av Google Business, lokal SEO så att du syns när kunder söker i ditt område, samt professionell presentation på sociala medier. Allt samlat hos en digital byrå." },
      { q: "Hur lång tid tar det att få en ny webbsida?", a: "En one-page hemsida i START-paketet är ofta klar inom 1–2 veckor. Större hemsidor med flera sidor, branding och copywriting tar vanligtvis 3–5 veckor beroende på hur snabbt vi får material från dig." },
      { q: "Var finns Nivå Digital och vilka jobbar ni med?", a: "Vi utgår från Stockholm men jobbar med småföretag i hela Sverige – städfirmor, hantverkare, byggföretag, salonger, bilverkstäder, trädgårdsfirmor och många fler. Kontakta Ibrahim Khalaf på 070-791 29 01 eller Sani Jawanmeri på 073-970 87 96." },
    ],
  },
  booking: {
    tag: "Nästa steg",
    heading1: "Redo att ta",
    headingAccent: "nästa steg?",
    text: "Låt oss göra ditt företag lika professionellt online som det är i verkligheten. Fyll i formuläret eller hör av dig direkt – vi återkommer alltid inom 24 timmar.",
    chip1: "Kostnadsfritt & utan förpliktelser",
    chip2: "Svar inom 24 timmar",
  },
  hero: {
    badge: "Digital byrå för svenska småföretag",
    heading1: "Ta ditt företag",
    heading2: "till",
    accent: "nästa nivå.",
    subtext:
      "Vi hjälper små företag att bygga en starkare digital närvaro – från varumärke och hemsida till Google och sociala medier.",
  },
};
